import React, { useState } from "react";
import ImageModal from "../Items Master/ImageModal";

const LocalPurchaseOrderItemsTable = ({ items, isOpen }) => {
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
    setSelectedImage("");
  };

  if (!isOpen) return null;

  return (
    <div className="overflow-x-auto mt-1 p-1 bg-white rounded-lg max-w-[95%] mx-auto mb-2">
      <div className="rounded-md overflow-x-auto">
        <table className="min-w-full table-auto rounded-lg overflow-scroll shadow-md border-spacing-0 border-collapse">
          <thead className="bg-gray-700 text-white tracking-wide">
            <tr>
              <th className="px-2 py-1 text-left font-normal">#</th>
              <th className="px-2 py-1 text-left font-normal">Item Name</th>
              <th className="px-2 py-1 text-left font-normal">Item Code</th>
              <th className="px-2 py-1 text-left font-normal">Item Image</th>
              <th className="px-2 py-1 text-left font-normal">Quantity</th>
              <th className="px-2 py-1 text-left font-normal">Price</th>
              <th className="px-2 py-1 text-left font-normal">Total</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {items.map((item, index) => (
              <tr
                key={item._id}
                className="border border-b divide-x text-gray-700 divide-gray-200 border-collapse border-gray-200 transition-colors duration-200"
              >
                <td className="px-2 py-0.5">{index + 1}</td>
                <td className="px-2 py-0.5">{item.itemName}</td>
                <td className="px-2 py-0.5">{item.itemCode}</td>
                <td className="px-2 py-0.5">
                  {item.itemImage ? (
                    <img
                      src={item.itemImage}
                      alt="Item img"
                      className="size-4 object-contain"
                      onClick={() => handleImageClick(item.itemImage)}
                    />
                  ) : (
                    "-"
                  )}
                </td>
                <td className="px-2 py-0.5">{item.itemQuantity}</td>
                <td className="px-2 py-0.5">{item.itemPrice}</td>
                <td className="px-2 py-0.5">{item.itemTotal}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isImageModalOpen && (
        <ImageModal imageUrl={selectedImage} onClose={closeImageModal} />
      )}
    </div>
  );
};

export default LocalPurchaseOrderItemsTable;
